import { BufferGeometry as i, BufferAttribute as n } from "three";
import { setColor as m } from "./index5.js";
function u(o, r) {
  const e = new i();
  e.setAttribute("position", new n(Float32Array.from(r), 3)), e.scale(o.size[0], o.size[1], o.size[2]), e.computeVertexNormals(), e.name = o.name, e.computeBoundingBox(), e.computeBoundingSphere(), m(e, o.color, o.alpha);
  let t;
  return e.index !== null ? (t = e.toNonIndexed(), e.dispose()) : t = e, t;
}
export {
  u as createDetailedGeometry
};
//# sourceMappingURL=index.js.map
